import { LocalStorageKey } from 'shared/constants/localStorage'
import { LocalStorageValue } from 'shared/types/localStorage'

export const lsGetItem = <T extends LocalStorageKey>(
  key: T,
  reviver?: (key: string, value: unknown) => unknown
): LocalStorageValue[T] | null => {
  const value = localStorage.getItem(key)
  if (!value) return null

  try {
    return JSON.parse(value, reviver) as LocalStorageValue[T]
  } catch {
    return value as LocalStorageValue[T]
  }
}
